import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { ThemeProvider } from '@mui/material';
import App from './App';
import { customTheme } from './theme';
import {
	FilterProvider,
	MenuProvider,
	SelectionProvider,
	ViewProvider,
	WeightProvider,
	YearProvider,
} from './context';
import { lloydConstants } from './Constants';
import { prefetchWave } from './useData';

const root = ReactDOM.createRoot(document.getElementById('root'));

const render = () =>
	root.render(
	<ThemeProvider theme={customTheme}>
		<MenuProvider>
			<YearProvider>
				<FilterProvider>
					<WeightProvider>
						<SelectionProvider>
							<ViewProvider>
								<App />
							</ViewProvider>
						</SelectionProvider>
					</WeightProvider>
				</FilterProvider>
			</YearProvider>
		</MenuProvider>
	</ThemeProvider>
	);

/**
 * The waves on offer come from data/waves.json rather than the bundle, so a new wave
 * is a data drop and not a rebuild. If the file is missing or unreadable the list
 * compiled into this build is used instead, which keeps an older deployment working.
 */
const bootstrap = async () => {
	performance.mark('resilience:bootstrap');

	// The manifest almost always names the wave this build already knows as newest,
	// so its data is requested now, in parallel, rather than after the manifest
	// comes back. If the manifest disagrees the one extra fetch is the whole cost.
	prefetchWave(lloydConstants.waves[0]);

	try {
		const response = await fetch('data/waves.json', { cache: 'no-cache' });

		if (response.ok) {
			const manifest = await response.json();
			const waves = (manifest.waves ?? [])
				.map(Number)
				.filter(Number.isInteger)
				.sort((a, b) => b - a);

			if (waves.length > 0) lloydConstants.waves = waves;
		}
	} catch (error) {
		// Keep the built-in list.
	}

	render();
};

bootstrap();
